import { __assign, __rest } from "tslib";
import React from 'react';
import { View, Image, TouchableOpacity, Dimensions } from 'react-native';
import { textStyle } from '../../../v2/theme/index.js';
import { PnmacText, PnmacRowItem, PnmacTable, PnmacHtmlToNative, PnmacActivityIndicator } from 'pnmac-universal-components';
import { encryptBankAccountNumber, testID } from '../../../utils.js';
import { SuccessMessage } from '../../../components/SuccessMessage.js';
import AddBankAccountDetails from "./AddBankAccountDetails.native.js";
import DeleteBankAccountNative from './DeleteBankAccount.native.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../../redux/events/events';
export default function BankAccounts(_a) {
  var _b;
  var matches = _a.matches,
    open = _a.open,
    closeModal = _a.closeModal,
    translations = _a.translations,
    layout = _a.layout,
    addBank = _a.addBank,
    deleteBank = _a.deleteBank,
    isOtp = _a.isOtp,
    bankAccounts = _a.bankAccounts,
    updateSelectedBankAccount = _a.updateSelectedBankAccount,
    navigation = _a.navigation,
    getSelectedBankAccount = _a.getSelectedBankAccount,
    updateSelectedView = _a.updateSelectedView,
    selectedView = _a.selectedView,
    trackerDispatcher = _a.trackerDispatcher,
    rest = __rest(_a, ["matches", "open", "closeModal", "translations", "layout", "addBank", "deleteBank", "isOtp", "bankAccounts", "updateSelectedBankAccount", "navigation", "getSelectedBankAccount", "updateSelectedView", "selectedView", "trackerDispatcher"]);
  var _c = React.useState(false),
    isAddingOrDeletingBankAccount = _c[0],
    setIsAddingOrDeletingBankAccount = _c[1];
  var _d = React.useState(""),
    error = _d[0],
    setError = _d[1];
  var _e = React.useState(undefined),
    deleteId = _e[0],
    setDeleteId = _e[1];
  var _f = React.useState({}),
    deleteAccount = _f[0],
    setDeleteAccount = _f[1];
  var _g = React.useState(true),
    canSubmitted = _g[0],
    setCanSubmitted = _g[1];
  var _h = React.useState(false),
    addBankAccountSuccess = _h[0],
    setAddBankAccountSuccess = _h[1];
  var _j = React.useState(false),
    deleteBankAccountSuccess = _j[0],
    setDeleteBankAccountSuccess = _j[1];
  var width = Dimensions.get('window').width;
  // const navigation= useNavigation();
  var unmount = function () {
    isOtp ? trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Payment Method-Back|Mobile', -1, '', false) : null;
  };
  React.useEffect(function () {
    if (bankAccounts.length > 0) {
      updateSelectedView("SelectBankAccount");
    } else {
      updateSelectedView("AddBankAccount");
    }
  }, [open]);
  React.useEffect(function () {
    navigation.addListener('blur', function () {
      // closeModal()
    });
    return unmount;
  }, []);
  var _k = React.useState({
      "bankRoutingNumberError": false,
      "bankAccountNumberError": false,
      "confirmAccountNumberError": false,
      "bankAccountTypeError": false,
      "bankAccountNameError": false,
      "nameOnBankAccountLengthError": false
    }),
    errors = _k[0],
    setErrors = _k[1];
  var _l = React.useState({
      "bankAccountId": "",
      "bankRoutingNumber": "",
      "bankAccountName": "",
      "bankAccountFirstName": "",
      "bankAccountMiddleName": "",
      "bankAccountLastName": "",
      "bankAccountType": "",
      "bankAccountNumber": "",
      "loanId": (_b = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber) === null || _b === void 0 ? void 0 : _b.toString(),
      "isDraftAccount": true,
      "isDrawAccount": false,
      "isHelocAccount": false,
      "isEDisbursementAccount": false,
      "createUser": "string",
      "updateUser": "string",
      "confirmAccountNumber": "",
      "unmaskedAccountNumber": ""
    }),
    bankAccount = _l[0],
    setBankAccount = _l[1];
  var bankAccountSelectionList = /*#__PURE__*/React.createElement(View, null, bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.map(function (accounts, index) {
    return [/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacRowItem, {
      key: "payment-method-".concat(index),
      rowContainerStyles: {
        borderBottomWidth: 2,
        borderBottomColor: "#E9E9E9",
        paddingVertical: 11,
        backgroundColor: "#FFF"
      },
      renderChildren: function () {
        var _a, _b, _c;
        return /*#__PURE__*/React.createElement(View, __assign({
          style: {
            height: 42,
            justifyContent: 'center'
          }
        }, testID("Addnewaccount-".concat(index))), /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID("updateSelectedBankAccount-".concat(index)), {
          onPress: function () {
            trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/ Payment Method-Select |Mobile', -1, accounts.accountNumber, false);
            updateSelectedBankAccount(accounts);
          },
          style: {
            marginLeft: 15
          }
        }), /*#__PURE__*/React.createElement(View, {
          style: {
            flexDirection: "row",
            alignItems: 'center'
          }
        }, accounts.unmaskedAccountNumber == ((_a = getSelectedBankAccount()) === null || _a === void 0 ? void 0 : _a.unmaskedAccountNumber) ? /*#__PURE__*/React.createElement(Image, {
          alt: "View details",
          source: require("./../../../assets/selected-green-tick-icon.jpg")
        }) : /*#__PURE__*/React.createElement(Image, {
          alt: "View details",
          source: require("./../../../assets/radio-icon-unselected.jpg")
        }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('bankacctype'), {
          style: {
            fontFamily: 'HalenoirCompactText-Medium',
            color: '#1B1B1B',
            padding: 5,
            fontSize: 14
          }
        }), "".concat((accounts === null || accounts === void 0 ? void 0 : accounts.bankAccountType) === 201286 ? "Checking Account" : (accounts === null || accounts === void 0 ? void 0 : accounts.bankAccountType) === 201287 ? "Saving Account" : (accounts === null || accounts === void 0 ? void 0 : accounts.bankAccountType) === 201288 ? "Debit Card" : "Add Account", " x"), (_c = (_b = accounts.accountNumber) === null || _b === void 0 ? void 0 : _b.toString()) === null || _c === void 0 ? void 0 : _c.slice(-4)), /*#__PURE__*/React.createElement(View, {
          style: {
            marginLeft: 'auto',
            marginRight: 15
          }
        }, /*#__PURE__*/React.createElement(Image, {
          alt: "View details",
          source: require("./../../../assets/cheveron-black-right.jpg")
        })))));
      }
    }))];
  }));
  var getSelectPaymentMethod = /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
    style: {
      marginLeft: width * 0.02,
      marginRight: width * 0.02
    }
  }, /*#__PURE__*/React.createElement(PnmacTable, {
    style: {
      margin: 10,
      backgroundColor: "#FFF",
      borderRadius: 10,
      shadowColor: "rgba(0,0,0, .08)",
      shadowOffset: {
        height: 4,
        width: 2
      },
      shadowOpacity: 1,
      shadowRadius: 12
    }
  }, matches.small && bankAccounts.length > 0 ? /*#__PURE__*/React.createElement(View, null, bankAccountSelectionList) : /*#__PURE__*/React.createElement(React.Fragment, null)), bankAccounts.length >= 5 && /*#__PURE__*/React.createElement(View, {
    style: {
      backgroundColor: '#F1BAB8',
      borderColor: '#F08580',
      borderRadius: 5,
      marginLeft: 10,
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row',
      padding: 12,
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      paddingRight: 5
    }
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "View details",
    source: require("./../../../assets/info-icon-red.png")
  })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('accountslimit'), {
    style: {
      color: '#333333',
      fontSize: 12,
      fontFamily: 'HalenoirCompactText-Medium',
      paddingRight: 10
    }
  }), "You can add up to a maximum of 5 bank accounts. Please remove a bank account from the list above before you can add a new bank account.")))), /*#__PURE__*/React.createElement(View, {
    style: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginLeft: 15,
      marginRight: 20,
      margin: 10
    }
  }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID("addBankAccountButton"), {
    onPress: function () {
      isOtp ? trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/ Payment Method-New Account|Mobile', -1, '', false) : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Autopay/ Payment Method-New Account|Mobile", -1, "", false);
      setDeleteBankAccountSuccess(false);
      setAddBankAccountSuccess(false);
      updateSelectedView("AddBankAccount");
      setError('');
    },
    disabled: bankAccounts != undefined && bankAccounts.length >= 5
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Image, {
    alt: "View details",
    source: require("./../../../assets/plus-icon-blue.jpg")
  })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('Addnewaccount'), {
    style: {
      fontSize: 14,
      color: '#117AAA',
      marginLeft: 10,
      maxWidth: 160
    }
  }), translations.PaymentMethodsAddNewAccount)))), /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID("removeBankAccountButton"), {
    onPress: function () {
      isOtp ? trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/ Payment Method-Remove Account |Mobile', -1, '', false) : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Autopay/ Payment Method-Remove Account |Mobile", -1, "", false);
      setDeleteBankAccountSuccess(false);
      setAddBankAccountSuccess(false);
      updateSelectedView("DeleteBankAccount");
      setError('');
    },
    disabled: bankAccounts != undefined && bankAccounts.length == 0
  }), /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Image, {
    alt: "View details",
    source: require("./../../../assets/cross-icon-blue.jpg")
  })), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('Removeaccount'), {
    style: {
      fontSize: 14,
      color: '#117AAA',
      marginLeft: 10
    }
  }), translations.PaymentMethodsRemoveAccount)))))));
  var onChangeBankAccountName = function (data) {
    setBankAccount(__assign(__assign({}, bankAccount), {
      "bankAccountFirstName": data.firstname,
      "bankAccountMiddleName": data.middleName || '',
      "bankAccountLastName": data.lastName,
      "bankAccountName": data.bankAccountName
    }));
  };
  var onChange = function (data, attribute) {
    var _a, _b;
    if (attribute == "bankAccountNumber") {
      setBankAccount(__assign(__assign({}, bankAccount), (_a = {}, _a[attribute] = data, _a.unmaskedAccountNumber = data, _a)));
    } else if (attribute == "bankAccountFirstName") {
      setBankAccount(function (prev) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[attribute] = data, _a.bankAccountName = [data, prev.bankAccountMiddleName, prev.bankAccountLastName].join(' '), _a));
      });
    } else if (attribute == "bankAccountMiddleName") {
      //MUST HAVE A SPACE FOR ADDING NEW BANK WHEN NO MIDDLE NAME PRESENTED
      setBankAccount(function (prev) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[attribute] = data, _a.bankAccountName = [prev.bankAccountFirstName, data, prev.bankAccountLastName].join(' '), _a));
      });
    } else if (attribute == "bankAccountLastName") {
      setBankAccount(function (prev) {
        var _a;
        return __assign(__assign({}, prev), (_a = {}, _a[attribute] = data, _a.bankAccountName = [prev.bankAccountFirstName, prev.bankAccountMiddleName, data].join(' '), _a));
      });
    } else {
      if (attribute === 'bankAccountType') {
        var msg = data === 201286 ? "Checking" : "Savings";
      }
      setBankAccount(__assign(__assign({}, bankAccount), (_b = {}, _b[attribute] = data, _b)));
    }
  };
  var deleteBankAccountFunc = function (func) {
    if (deleteAccount.confirmAccountNumber == deleteAccount.bankAccountNumber) {
      setError("");
      setAddBankAccountSuccess(false);
      setDeleteBankAccountSuccess(false);
      deleteAccount.bankAccountType = deleteAccount.bankAccountType == 201286 ? 1 : 2;
      deleteAccount.bankAccountNumber = deleteAccount.unmaskedAccountNumber;
      setIsAddingOrDeletingBankAccount(true);
      fetch("".concat(layout.pennyHomeUrl, "api/payment/delete_bank_account_payments"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(__assign(__assign({}, deleteAccount), {
          bankAccountNumber: undefined,
          bankAccountNumberEncode: encryptBankAccountNumber(deleteAccount.bankAccountNumber)
        }))
      }).then(function (res) {
        return res.text();
      }).then(function (data) {
        deleteBank(deleteAccount);
        setDeleteBankAccountSuccess(true);
        setIsAddingOrDeletingBankAccount(false);
        updateSelectedView("SelectBankAccount");
        if (data == "true") {
          setAddBankAccount(false);
          setBankAccount(__assign(__assign({}, bankAccount), {
            bankRoutingNumber: "",
            bankAccountName: "",
            bankAccountType: "",
            bankAccountNumber: "",
            confirmAccountNumber: ""
          }));
        } else {
          setIsAddingOrDeletingBankAccount(false);
        }
      });
    } else {
      setError("*Please confirm your bank account number!");
    }
  };
  var addBankAccountFunc = function () {
    var _a, _b, _c;
    setErrors(__assign(__assign({}, errors), {
      bankRoutingNumberError: false,
      bankAccountNumberError: false,
      confirmAccountNumberError: false,
      bankAccountTypeError: false,
      bankAccountNameError: false
    }));
    if (bankAccount.confirmAccountNumber == bankAccount.bankAccountNumber) {
      if (bankAccount.bankAccountType == null) {
        setError("Please select the valid Bank Account Type");
      } else {
        setError("");
        setAddBankAccountSuccess(false);
        var account = (_b = (_a = layout.paymentModel) === null || _a === void 0 ? void 0 : _a.bankAccounts) === null || _b === void 0 ? void 0 : _b.filter(function (s) {
          return s.unmaskedAccountNumber == bankAccount.unmaskedAccountNumber && s.routingTransitNumber == bankAccount.bankRoutingNumber;
        });
        if ((account === null || account === void 0 ? void 0 : account.length) > 0) {
          setError("*Bank Account details already exist. Please use a unique account number!");
        } else {
          setIsAddingOrDeletingBankAccount(true);
          bankAccount.bankAccountType = bankAccount.bankAccountType == 201286 ? 1 : bankAccount.bankAccountType == 201287 ? 2 : null;
          bankAccount.routingTransitNumber = bankAccount.bankRoutingNumber;
          bankAccount.accountNumber = bankAccount.unmaskedAccountNumber.replace(/\d(?=\d{4})/g, "*");
          bankAccount.accountName = bankAccount.bankAccountName;
          addBank(__assign(__assign({}, bankAccount), {
            unmaskedAccountNumber: bankAccount.bankAccountNumber,
            accountNumber: bankAccount.accountNumber,
            bankAccountType: bankAccount.bankAccountType == 1 ? 201286 : bankAccount.bankAccountType == 2 ? 201287 : null
          }));
          setIsAddingOrDeletingBankAccount(false);
          setBankAccount({
            "bankAccountId": "",
            "bankRoutingNumber": "",
            "bankAccountName": "",
            "bankAccountFirstName": "",
            "bankAccountMiddleName": "",
            "bankAccountLastName": "",
            "bankAccountType": "",
            "bankAccountNumber": "",
            "loanId": (_c = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber) === null || _c === void 0 ? void 0 : _c.toString(),
            "isDraftAccount": true,
            "isDrawAccount": false,
            "isHelocAccount": false,
            "isEDisbursementAccount": false,
            "createUser": "string",
            "updateUser": "string",
            "confirmAccountNumber": "",
            "unmaskedAccountNumber": ""
          });
          updateSelectedView("SelectBankAccount");
          setAddBankAccountSuccess(true);
        }
      }
    } else {
      setError("*Please confirm your bank account number!");
    }
  };
  return /*#__PURE__*/React.createElement(View, null, isAddingOrDeletingBankAccount ? /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "coloumn",
      justifyContent: "center",
      alignItems: 'center',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(PnmacActivityIndicator, null)) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, rest, {
    layout: layout,
    source: translations.NickNameBanner
  })), addBankAccountSuccess ? /*#__PURE__*/React.createElement(SuccessMessage, {
    onClick: function () {
      return setAddBankAccountSuccess(false);
    },
    message: translations.BankAccounSuccessMsg
  }) : null, deleteBankAccountSuccess ? /*#__PURE__*/React.createElement(SuccessMessage, {
    onClick: function () {
      return setDeleteBankAccountSuccess(false);
    },
    message: "Bank account removed successfully"
  }) : null, /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('bankaccounterror'), {
    idTag1: 'lblBankAccountErrorMsg',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }), error)), /*#__PURE__*/React.createElement(View, null), (selectedView == 'SelectBankAccount' || selectedView == 'PaymentMethodSelectBankAccount') && /*#__PURE__*/React.createElement(View, null, getSelectPaymentMethod), selectedView == 'AddBankAccount' || selectedView == 'PaymentMethodAddBankAccount' ? /*#__PURE__*/React.createElement(AddBankAccountDetails, {
    errors: errors,
    disabled: true,
    isOtp: isOtp,
    layout: layout,
    matches: matches,
    setError: setError,
    setCanSubmitted: setCanSubmitted,
    canSubmitted: canSubmitted,
    translations: translations,
    bankAccount: bankAccount,
    onChange: onChange,
    setErrors: setErrors,
    addBankAccountFunc: addBankAccountFunc,
    onChangeBankAccountName: onChangeBankAccountName,
    trackerDispatcher: trackerDispatcher
  }) : null, (selectedView == 'DeleteBankAccount' || selectedView == 'PaymentMethodDeleteBankAccount') && /*#__PURE__*/React.createElement(DeleteBankAccountNative, {
    trackerDispatcher: trackerDispatcher,
    bankAccounts: bankAccounts,
    deleteId: deleteId,
    layout: layout,
    deleteAccount: deleteAccount,
    setDeleteAccount: setDeleteAccount,
    setDeleteId: setDeleteId,
    deleteBankAccountFunc: deleteBankAccountFunc,
    translations: translations,
    isOtp: isOtp
  })));
}